// tslint:disable
/**
 * @module support/pdl
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

import { Component, OnInit, OnDestroy, HostListener, Renderer2 } from '@angular/core';
import { PdlService } from '.././services/pdl.service';
import { NgRadio } from '../components/ng-radio.component';
import { PdlDataInterface, PdlDataRootInterface } from '../interfaces/pdl-data.interface';
import { PdlEventDataObject } from '../interfaces/pdl-data.interface';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'pdl',
  template: `<span></span>`,
})
export class PdlComponent implements OnInit, OnDestroy {
  public previousUrl: string;
  public PDLPageData: PdlDataInterface;
  public PDLMockData: PdlDataRootInterface;
  private disableClickEventListener: Function;
  private disableChangeEventListener: Function;
  constructor(
    public pdlService: PdlService,
    public eventBus: NgRadio,
    private renderer: Renderer2
  ) {
    this.eventBus.on('pdl: disable-tracking-event').subscribe(() => {
      if (this.disableChangeEventListener) {
        this.disableChangeEventListener();
      }

      if (this.disableClickEventListener) {
        this.disableClickEventListener();
      }
    });

    this.eventBus.on('pdl:enablePDL:EventListeners').subscribe((data: any) => {
      if (!this.disableClickEventListener) {
        console.log('PDL:Component: Recieved Event Config, registering listener click');
        this.disableClickEventListener = this.renderer.listen('window', 'click', (event) => {
          this.processPDL(event);
        });
      }
      if (!this.disableChangeEventListener) {
        console.log('PDL:Component: Recieved Event Config, registering listener change');
        this.disableChangeEventListener = this.renderer.listen('window', 'change', (event) => {
          this.processPDL(event);
        });
      }
    });
  }

  public ngOnInit(): void {}

  /**
   * Destroys the configuration of retail component
   * @return void
   */
  public ngOnDestroy(): void {
    if (this.disableChangeEventListener) this.disableChangeEventListener();
    if (this.disableClickEventListener) this.disableClickEventListener();
  }

  // processing window resize events
  @HostListener('window:resize', ['$event'])
  private onResize(event: {}): void {}

  // processing online events
  @HostListener('window:online', ['$event'])
  private onOnline(event: {}): void {}

  // processing offline events
  @HostListener('window:offline', ['$event'])
  private onOffline(event: {}): void {}

  // tslint:disable-next-line:no-any
  private getEventTarget(event: any): any {
    return event.detail && event.detail.type ? event.detail : event;
  }

  // tslint:disable-next-line:cyclomatic-complexity
  private processEvent(
    target: {
      detail: {};
      attributes: {
        tmoPdl: {};
        pdlcmpid: Node;
        pdlCtaId: Node;
        pdlFields: Node;
        pdlEvents: { nodeValue: string };
      };
    },
    type: string,
    componentId: string,
    repeatedComponent: boolean
  ): void {
    // console.log('pdl:processEvent:Target ', target);
    const pdlData: PdlEventDataObject = this.setPdlEventDataObject(
      target,
      type,
      componentId,
      repeatedComponent
    );
    if (
      pdlData &&
      pdlData.cmpId &&
      (!pdlData.events || pdlData.events.indexOf(pdlData.action) >= 0)
    ) {
      if (this.pdlService.enabled(pdlData)) {
        let context = this.pdlService.getPersistedData(pdlData.cmpId);
        if (context) {
          this.pdlService.populateEventObject(pdlData, context);
        } else {
          this.eventBus.cast('pdl:capture-data-event', pdlData);
        }
      }
    }
  }

  private setPdlEventDataObject(
    target: {
      detail: {};
      attributes: {
        id?: Node;
        tmoPdl: {};
        pdlcmpid: Node;
        pdlCtaId: Node;
        pdlFields: Node;
        pdlEvents: { nodeValue: string };
      };
    },
    type: string,
    componentId: string,
    repeatedComponent: boolean
  ): PdlEventDataObject {
    if (target && target.attributes && target.attributes.tmoPdl) {
      return {
        action: type,
        cmpId: (target.attributes.pdlcmpid && target.attributes.pdlcmpid.nodeValue) || componentId,
        ctaId:
          (target.attributes.pdlCtaId && target.attributes.pdlCtaId.nodeValue) ||
          (target.attributes.id && target.attributes.id.nodeValue),
        fields: target.attributes.pdlFields && target.attributes.pdlFields.nodeValue.split(','),
        repeatedComponent: repeatedComponent,
        events: target.attributes.pdlEvents && target.attributes.pdlEvents.nodeValue.split(','),
      };
    }
  }

  private processPDL(event: { type: string }): void {
    let componentId: string;
    let repeatedComponent: boolean = false;
    if (event) {
      const target = this.getEventTarget(event);
      if (target && target.path && Array.isArray(target.path)) {
        const topDownPath = target.path.reverse();
        for (const pathElem of topDownPath) {
          if (pathElem && pathElem.attributes && pathElem.attributes.pdlPageComponentId) {
            componentId = pathElem.attributes.pdlPageComponentId.nodeValue;
            repeatedComponent =
              pathElem.attributes.pdlRepeatedComponent &&
              pathElem.attributes.pdlRepeatedComponent.nodeValue == 'true';
          }
          this.processEvent(pathElem, target.type, componentId, repeatedComponent);
        }
      }
    }
  }
}
